import React from 'react';

// @material-ui/core components
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

const CustomRadioButton = props => {
  const { label, selectedValue, value, name, handleChange } = props;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
      <Radio
        checked={selectedValue === value}
        onChange={e => handleChange(e.target.value)}
        value={value}
        color="default"
        name={name}
        inputProps={{ 'aria-label': 'E' }}
        icon={<RadioButtonUncheckedIcon fontSize="small" />}
        checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
      />
      <InputLabel shrink htmlFor={name}>
        {label}
      </InputLabel>
    </div>
  );
};

export default CustomRadioButton;
